import React from 'react';
import { Contact } from '../components/Contact';
export function ContactPage() {
  return <main className="pt-24" data-id="element-226">
      <Contact data-id="element-227" />
    </main>;
}